import { useQuery, useMutation, useQueryClient } from 'react-query';
import { useParams } from 'react-router-dom';

import api from 'api';

export function GETSingleMissionChecks({ queryKey }) {
  const [, { params, missionId }] = queryKey;

  return api.get.singleMissionChecks(missionId, params);
}

export function PATCHChecks(checkId) {
  return payload => api.patch.checks(checkId, payload);
}

export function POSTSingleMissionChecks(missionId) {
  return payload => api.post.singleMissionChecks(missionId, payload);
}

export function GETSingleCheck({ queryKey }) {
  const [, checkId, params] = queryKey;
  return api.get.singleCheck(checkId, params);
}

/**
 * Checks hooks
 */
export function useGetSingleMissionChecks(params = {}, options = {}) {
  const { missionId } = useParams();
  return useQuery(
    ['single mission checks', { params, missionId }],
    GETSingleMissionChecks,
    options,
  );
}

export function useGetSingleCheck(checkId, params = {}, options = {}) {
  return useQuery(['Get singleCheck', checkId, params], GETSingleCheck, options);
}

export function usePostSingleMissionChecks(missionId) {
  const queryClient = useQueryClient();
  return useMutation(POSTSingleMissionChecks(missionId), {
    onSettled: () => {
      queryClient.invalidateQueries('missions');
    },
  });
}

export function usePatchChecks(checkId) {
  const queryClient = useQueryClient();
  return useMutation(PATCHChecks(checkId), {
    onSuccess: () => {
      queryClient.invalidateQueries('single mission checks');
      queryClient.invalidateQueries('single mission stats');
    },
  });
}
